<template>
    <div class="ed video-tree">
        <el-form  style="width: 500px;" :model="formData" ref="formRef" label-width="130px" size="mini">
            <h3 style="text-align: center;"><span v-if="i_id==0"></span>基本信息</h3>
            <div style="display: flex">
            <el-form-item style="color: black" class="ml form-title" label="方案名称" >
                <el-input  v-model="formData.vc_tcname"  :disabled="edit" style="width: 98%">
                </el-input>
            </el-form-item>
            <el-form-item style="color: black" class="ml form-title" label="调休小时计算比率" >
                <span>{{formData.f_ratio}}</span>
            </el-form-item>
            </div>
            <div style="display: flex">
            <el-form-item class="ml form-title" label="套餐标识" >
                <el-input  v-model="formData.vc_djmark" v-if="i_id==0" style="width: 95%">
                </el-input>
                <span v-else>{{formData.vc_djmark}}</span>
            </el-form-item>
            <el-form-item class=" form-title" label="单双休" style="margin-left:12px ;">
                <el-select @change="change" v-model="formData.i_weektype" :disabled="edit" placeholder="请选择" style="width: 95%">
                    <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.lable"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            </div>
            <div class="item">
                <el-form-item class="ml form-title"  label="周期起始日" >
                    <el-date-picker
                            style="width: 87%"
                            :disabled="edit"
                            v-model="formData.i_start"
                            format="dd"
                            value-format="dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-title" label="周期结束日" >
                    <el-date-picker
                            style="width: 95%"
                            :picker-options="pickerOptions"
                            :disabled="edit"
                            v-model="formData.i_end"
                            format="dd"
                            value-format="dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="formDiv flex">
                <el-form-item class="ml form-title"  label="录入人" >
                    <el-input  v-model="formData.vc_createuser" disabled  style="width:88%">
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title"  label="录入时间" style="margin-left: 0px">
                    <el-input  v-model="formData.dt_createtime" disabled  style="width:95%">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center;width: 500px">
            <el-button  type="primary" @click="save" :class="baseerp+'btn'"  :disabled="disabled" size="mini" v-if="!isDesk">{{$t('button_save')}}</el-button>
            <el-button type="primary" @click="bianji" :class="baseerp+'btn'"  :disabled="disabled" size="mini" v-if="isDesk">编辑</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";

    export default {
        name: "BasicInformation",
        props:{
            formvalue:{
                type:Object,
                required:true,

            }
        },
        data() {
            return {
                isDesk:false,
                baseerp:"",
                edit:false,
                formData:{
                    i_id:0,
                    vc_djmark:'',
                    vc_tcname:'',
                    i_start:'',
                    i_end:'',
                    dt_createtime:'',
                    vc_createuser:'',
                    i_weektype:''
                },
                options:[{
                    id:1,
                    lable:'单休'
                },{
                    id:2,
                    lable:'双休'
                },
                ],
                i_id:0,
                i_type:9,
                lastTime:"",
                disabled:false,
                mid:0,
                value:''
            }
        },
        watch:{
            formvalue:{
                handler(){
                    if (this.formvalue){
                        if(this.formvalue.i_id==0){
                            this.isDesk=false
                        }else {
                            this.isDesk=true
                        }
                        // this.getList()
                            // if(this.formvalue.i)
                            this.formData.vc_tcname=this.formvalue.vc_tcname;
                            this.formData.vc_djmark=this.formvalue.vc_djmark;
                            this.formData.i_start=this.formvalue.i_start;
                            this.formData.i_end=this.formvalue.i_end;
                            this.formData.vc_createuser=this.formvalue.vc_createuser;
                            this.formData.dt_createtime=this.formvalue.dt_createtime;
                            this.formData.i_weektype=this.formvalue.i_weektype;
                        this.formData.f_ratio=this.formvalue.f_ratio;
                        this.i_id=this.formvalue.i_id;
                        // Object.assign(this.formData,  this.formvalue);

                        //this.formData.i_id=this.formvalue.i_id;

                        if (this.i_id!=0){
                            this.edit = true;
                        }else{
                            this.edit = false;
                            this.newData();
                        }
                    }
                },
                immediate:true,
                deep:true
            }

        },

        mounted() {
            // this.formData.vc_lruname=sessionStorage.getItem("lruname"),;
            this.baseerp=baseerp;
// this.getList()
//             //console.log(this.i_id)

        },
        computed:{
            //禁止跨月
            pickerOptions(){
                let _this = this
                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            change(val){
                this.formData.i_weektype=val
                // console.log(val)
            },
            //新增赋值
            newData(){
                this.form=this.formvalue;
                this.i_id=this.form.i_id;
                this.i_type=this.form.i_type;
                this.disabled = false;
                this.formData = {
                    i_id:0,
                    vc_djmark:'',
                    vc_tcname:'',
                    i_start:'',
                    i_end:'',
                    dt_createtime:'',
                    vc_createuser:'',
                    i_weektype:'',
                    vc_createuser: sessionStorage.getItem("lruname"),
                };

                this.edit = false;
                this.getDateYYYYMMddHHMMSS();
            },
            bianji(){
                // console.log(this.formData.i_weektype)
                this.isDesk=!this.isDesk
                this.edit=!this.edit
            },

            async getList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_mid:this.mid
                }
                let res=await API.getKqList(param)
                if(res.code==1){
                    // this.formData=res.data

                    // console.log(res,13123)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            save(){
                // console.log(this.formvalue.i_id)
                if(this.formvalue.i_id==0){
                    this.isDesk=false
                }else
                {
                    this.isDesk=true
                    this.edit=!this.edit
                }

                this.addsaveKq()
                // console.log(this.formData.vc_tcname)
                // this.addsaveKq()
            },
            async addsaveKq(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_id:this.formvalue.i_id,
                    vc_djmark:this.formData.vc_djmark,
                    vc_tcname:this.formData.vc_tcname,
                    i_start:this.formData.i_start,
                    i_end:this.formData.i_end,
                    dt_createtime:this.formData.dt_createtime,
                    i_weektype:this.formData.i_weektype,
                    vc_createuser:this.formData.vc_createuser ,
                }
                let res=await API.addsaveKq(param)
                if(res.code==1){
                    // this.getList()
                    // this.formData=res.data
                    // let data=res.data;
                    this.$emit('proDetails',param);
                    // this.i_id=res.scorder.i_id;
                    // Object.assign(this.formvalue,  param);

                    // this.disabled=true;
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            taskList(data){
                // console.log("data------",data);
                let val={
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }

            },
            cancel(){},
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            // getLastDay(val){
            //     let date=new Date(this.formData.begintime);
            //     date.setDate(28);
            //     date.setMonth(date.getMonth()+1);
            //     let lastDay=date.setDate(0);
            //     let allDay= new Date(lastDay).toString();
            //     const lastdate = new Date(allDay);
            //     const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
            //     const strDate = lastdate.getDate().toString().padStart(2, '0');
            //     //return `${date.getFullYear()}-${month}-${strDate}`;
            //     this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
            //     this.$set(this.formData, "endtime",this.lastTime)
            //     // console.log( value)
            // },
        },
    }
</script>

<style lang="scss" scoped>
    .ml{
        margin-left: 25px;
    }
    .ed{
        min-width: 600px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/ .is-disabled .el-input__inner{
        color: black !important;
    }
    /deep/{
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .el-tabs--border-card>.el-tabs__content{
            overflow: auto;
        }
        /*.el-table td,.el-table td, .el-table th {
            padding: 8px 0;
        }*/
        .danger-row{
            color: #999;

        }

    }
/*/deep/.el-form-item__label{*/
/*    width: 0;*/
/*}*/

</style>